import { IonText } from '@ionic/react';

import styles from '@/components/Clients/EmptyClientsState.module.css';
import { Icon } from '@/components/Icon';

type EmptyClientStateProps = {
  isSearching: boolean;
  query?: string;
};

export const EmptyClientsState = ({ isSearching, query }: EmptyClientStateProps) => {
  return (
    <>
      <div className={styles.wrapper}>
        <Icon color='var(--ion-color-grey500)' name='person' />
        <h1 className={styles.title}>{isSearching ? `No client(s) found for "${query}"` : 'Add your clients'}</h1>
        <IonText className={styles.description}>
          {isSearching
            ? 'No clients found for this search query. Please try again with a different query.'
            : 'Start tracking movement data and analysis for your clients. Each client can be associated with their test sessions.'}
        </IonText>
      </div>
    </>
  );
};
